import { useRef, useState } from 'react';
import { api } from '../lib/api.js';

const MAX_BYTES = 20 * 1024 * 1024;

export default function TranscriptUploader({ endpoint, transcript, onUploaded }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);

  async function onPick(e) {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > MAX_BYTES) {
      setError('That transcript is over 20 MB. Please use a smaller PDF.');
      return;
    }
    setError(null);
    setUploading(true);
    try {
      const form = new FormData();
      form.append('transcript', file);
      const body = await api.upload(endpoint, form);
      if (!body?.transcript) throw new Error('Upload succeeded but no transcript record came back.');
      onUploaded(body.transcript, body.profile);
    } catch (err) {
      setError(err.body?.error || err.message);
    } finally {
      setUploading(false);
    }
  }

  return (
    <div className="rounded border border-gray-200 bg-gray-50 p-3">
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,.pdf"
        className="hidden"
        onChange={onPick}
      />
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="text-sm font-bold text-hunter">
            {transcript?.fileName || 'No transcript uploaded'}
          </div>
          <p className="text-xs text-silver-mute mt-1">
            PDF up to 20 MB. The file stays private; a published profile opens it through a short-lived link.
          </p>
        </div>
        <button
          type="button"
          className="btn-secondary"
          disabled={uploading}
          onClick={() => inputRef.current?.click()}
        >
          {uploading ? 'Uploading...' : transcript ? 'Replace transcript' : 'Upload transcript'}
        </button>
      </div>
      {error && <p className="text-xs text-red-700 mt-2">{error}</p>}
    </div>
  );
}
